module.exports = __webpack_public_path__ + "media/country_flags/ph-384da2fc.png";